/**
 * Onboarding step configuration and constants
 */
import React, { ReactNode } from "react";

export const ONBOARDING_MESSAGES = {
  CEX_DISCLAIMER: (
    <>
      <strong>**</strong> Funds are trade-only and cannot be withdrawn once linked.
    </>
  ) as ReactNode,
  ELIGIBLE_TO_TRADE: "You're eligible to trade.",
  WALLET_DISCONNECTED: "Wallet disconnected successfully",
  WALLET_DISCONNECT_FAILED: "Failed to disconnect wallet",
  REFERRAL_CODE_SAVED: "Referral code saved! It will be applied when you connect your wallet.",
  REFERRAL_CODE_REQUIRED: "Please enter a referral code",
} as const;

export const ONBOARDING_STEP_TITLES = {
  CREATE_ACCOUNT: {
    CONNECTED: "Account Connected!",
    NOT_CONNECTED: "Welcome to Cede Hub!",
  },
  LINK_CEX: "Connect Exchange",
  CONNECT_SOCIAL: "Connect Social",
} as const;

export const ONBOARDING_STEP_DESCRIPTIONS = {
  LINK_CEX: "Connect your exchange account to start trading",
  CONNECT_SOCIAL: "Connect at least one social account to participate in campaigns and earn additional rewards",
} as const;

export const WALLET_TYPES = {
  EVM: "evm",
  TON: "ton",
} as const;

export type WalletType = (typeof WALLET_TYPES)[keyof typeof WALLET_TYPES];
